import React from "react";
import './EditServiceMaster.css';
import { useNavigate } from "react-router-dom";
const EditServiceMaster=()=>{
  const navigate =useNavigate();
     // Cancel button handler
     const handleCancelButtonClick = () => {
      navigate('/serviceMaster');
  };
    return(
        <div className="Edit-Service-Master">
        <div className="edit-service">
          {/* <h3>Service Master</h3> */}
        </div>
        <div className="edit-container">
          <div className="edit-Header">
            <h3>Edit Service Master</h3>
          </div>
          <div className="edit-container-body">
            <div className="edit-form">
              <label className="editService-label">Service Id</label>
              <input className="editService-input" type="text" placeholder=" " />
            </div>
            <div className="edit-form">
              <label className="editService-label">Service Name</label>
              <input className="editService-input" type="text" placeholder=" " />
            </div>
            <div className="edit-form">
              <label className="editService-label">Parent Id</label>
              <input className="editService-input" type="text" placeholder=" " />
            </div>
            <div className="edit-form">
              <label className="editService-label">Display Order</label>
              <input className="editService-input" type="text" placeholder=" " />
            </div>

            <div className="editServiceButtons">
                <button className="editService-btn">UPDATE</button>
                <button className="btn-editService"onClick={handleCancelButtonClick}>CANCLE</button>
            </div>

          </div>
        </div>
      </div>
    );
}
export default EditServiceMaster;